
import "./TestStyles.css";
import { handleOnPopState } from '../utils/pop_state_utils.js';
import React, { useState, useEffect, useCallback } from "react";
import { UpdateLocalStorage } from '../db/localstorage_utils.js';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { playInstructionsOnce, handleAudioEndedCommon } from '../utils/audio_utils.js';

import { calculate_progress } from "../utils/progress_bar.js";
 

const QuestionFourteenDScreen = ({ userData }) => {
  const [audio] = useState(new Audio("/audio/q14D_instructions.mp3"));
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [nextButtonStyle, setNextButtonStyle] = useState("NextButton");
  const [audioPlayed, setAudioPlayed] = useState(false);
  const results = JSON.parse(localStorage.getItem("results"));
  const navigate = useNavigate();
  const location = useLocation();
  const [nextPage] = useState("/Q15Screen");        // Where this screen will navigate to next
  const [thisPage] = useState("screen_14_d");  
    const handleAudioEnded = useCallback(() => {
    handleAudioEndedCommon({
      audio,
      onEnded: handleAudioEnded,
      setAudioPlayed,
      setButtonDisabled,
      setNextButtonStyle
    });
  }, [audio]);

   
  // Implementing the popstate handler
  window.onpopstate = () => {
    handleOnPopState({ results, userData, navigate, location });
  };

  /* The `useEffect` hook makes sure that the instruction audio is played only once and that the images can only be interacted with after
  * the instructions are finished.
  */
  useEffect(() => {
   if (!audioPlayed) {
     playInstructionsOnce({ audio, audioPlayed, setAudioPlayed, onEnded: handleAudioEnded });
   }
 }, [audio, audioPlayed, handleAudioEnded]);

  /**
   * The function evaluates which icon the user clicked and updates the results in local storage
   * before navigating to the next screen.
   * @param e - The parameter `e` is an event object that contains data on which icon was clicked.
   */
 const evaluateSelection = (e) => {
  if (e.target.alt === "Anchor") {
    results[thisPage] = true;
  } else {
    results[thisPage] = false;
  }
  localStorage.setItem("results", JSON.stringify(results));
  navigate(nextPage);
};

  return (
    <div className="Container">
      <div className="InstructionsContainer">
        <img className="CharacterIcon" src="/icons/other.png" alt="Character Icon" />
        <progress variant="custom" className="ProgressBar" value={calculate_progress('asymptotic', 38, 54)} max="1"></progress>
        <p className="Instructions">Select the object that has a nautical connection.</p>
      </div>
      <div className="whiteScreenGrid">
        <div className="whiteScreenGridCols">
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/spoon.png" alt="Spoon" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/penguin.png" alt="Penguin" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/harp.png" alt="Harp" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/crown.png" alt="Crown" />
            </button>
          </div>
        </div>

        <div className="whiteScreenGridCols">
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/book.png" alt="Book" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/anchor.png" alt="Anchor" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/rhinoceros.png" alt="Rhinoceros" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/alligator.png" alt="Alligator" />
            </button>
          </div>
        </div>

        <div className="whiteScreenGridCols">
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/kangaroo.png" alt="Kangaroo" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/camel.png" alt="Camel" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/barrel.png" alt="Barrel" />
            </button>
          </div>
          <div className="iconContainer">
            <button disabled={buttonDisabled} onClick={evaluateSelection}>
              <img className="gridIcons" src="/icons/accordion.png" alt="Accordion" />
            </button>
          </div>
        </div>
      </div>

      <div className="NextButtonContainer">
        <Link to={nextPage}>
          <button disabled={buttonDisabled} onClick={() => UpdateLocalStorage( false, thisPage )} className={nextButtonStyle}>
            <img src="/icons/arrow.png" alt="Next Button" />
          </button>
        </Link>
      </div>
    </div>
  );
};

export default QuestionFourteenDScreen;
